import { stdevAndMean } from "lib/customMath.js";

export function parseDuoTierList(data) {
  const [duoData, lastUpdated, totalMatches] = data;

  const duoPairs = Object.keys(duoData);

  let roleOrder1, roleOrder2;

  duoPairs.forEach((duo) => {
    duoData[duo] = duoData[duo].map((championData) => {
      if (championData[1] === 1 && championData[5] === 5) {
        roleOrder1 = 2;
        roleOrder2 = 1;
      } else if (championData[1] === 1 && championData[5] === 4) {
        roleOrder1 = 2;
        roleOrder2 = 1;
      } else {
        roleOrder1 = 1;
        roleOrder2 = 2;
      }
      const cleanData = {
        [`duo_${roleOrder1}`]: championData[0],
        [`duo_${roleOrder1}_role`]: championData[1],
        [`duo_${roleOrder1}_wins`]: championData[2],
        [`duo_${roleOrder1}_matches`]: championData[3],
        [`duo_${roleOrder2}`]: championData[4],
        [`duo_${roleOrder2}_role`]: championData[5],
        [`duo_${roleOrder2}_wins`]: championData[6],
        [`duo_${roleOrder2}_matches`]: championData[7],
        duo_combined_wins: championData[8],
        duo_combined_matches: championData[9],
        duo_bans: championData[10],
      };

      let {
        duo_1,
        duo_1_role,
        duo_1_wins,
        duo_1_matches,
        duo_2,
        duo_2_role,
        duo_2_wins,
        duo_2_matches,
        duo_combined_wins,
        duo_combined_matches,
        duo_bans,
      } = cleanData;

      cleanData["duo_1_link"] = {
        championId: duo_1,
        role: duo_1_role,
      };
      cleanData["duo_2_link"] = {
        championId: duo_2,
        role: duo_2_role,
      };
      cleanData["duo_1_winrate"] = (duo_1_wins / duo_1_matches) * 100;
      cleanData["duo_2_winrate"] = (duo_2_wins / duo_2_matches) * 100;
      cleanData["duo_combined_winrate"] = (duo_combined_wins / duo_combined_matches) * 100;
      cleanData["duo_combined_banrate"] = (duo_bans / totalMatches) * 100;
      cleanData["duo_combined_pickrate"] = (duo_combined_matches / totalMatches) * 100;
      cleanData["plus_minus_winrate"] =
        cleanData.duo_combined_winrate - Math.sqrt(cleanData.duo_1_winrate * cleanData.duo_2_winrate);

      const effective_winrate =
        (cleanData.duo_combined_banrate / 100) *
          (((cleanData.duo_combined_winrate * (1 + cleanData.plus_minus_winrate)) / 100 + 0.55) / 2) +
        (cleanData.duo_combined_pickrate / 100) * ((cleanData.duo_combined_winrate * (1 + cleanData.plus_minus_winrate)) / 100) +
        (1 - cleanData.duo_combined_banrate / 100 - cleanData.duo_combined_pickrate / 100) * 0.5;
      cleanData["effective_winrate"] = effective_winrate * 100;

      return cleanData;
    });
  });

  duoPairs.forEach((duo) => {
    const effective_winrates = duoData[duo].map((x) => x.effective_winrate);
    // console.log(effective_winrates)
    const maths = stdevAndMean(effective_winrates);
    // console.log(maths)

    duoData[duo].forEach((championData) => {
      championData["stdevs"] = (championData.effective_winrate - maths.mean) / maths.stdev;
    });

    duoData[duo].sort((a, b) => {
      return b.duo_combined_winrate - a.duo_combined_winrate;
    });
  });
  //
  // console.log(data)
  return data;
}
